import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useAuth } from './AuthContext';

function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setTokensAndUser, updateGroups } = useAuth();
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    const code = searchParams.get('code');
    const error = searchParams.get('error');

    // URL에서 code 즉시 제거 (보안)
    window.history.replaceState({}, document.title, '/oauth/callback');

    if (error) {
      toast.error(t('login.oauthError'));
      navigate('/login');
      return;
    }

    if (!code) {
      toast.error(t('login.oauthError'));
      navigate('/login?error=no_code');
      return;
    }

    const exchangeCode = async () => {
      try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
        const response = await fetch(`${backendUrl}/api/v1/auth/oauth/exchange`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ code })
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
          toast.error(t('login.oauthError'));
          navigate('/login?error=exchange_failed');
          return;
        }

        // AuthContext에 토큰 저장 (refreshToken은 HttpOnly 쿠키로 자동 설정됨)
        setTokensAndUser(data.accessToken);

        // 사용자 그룹 fetch
        try {
          const groupResponse = await fetch(`${backendUrl}/api/v1/user/user_groups`, {
            headers: {
              'Authorization': `Bearer ${data.accessToken}`,
              'Content-Type': 'application/json'
            },
            credentials: 'include',
          });

          if (groupResponse.ok) {
            const groupData = await groupResponse.json();
            updateGroups(groupData.groups);
          }
        } catch {
          // 그룹 fetch 실패해도 로그인은 성공 상태이므로 무시
        }

        toast.success(t('login.oauthSuccess'));
        navigate('/');
      } catch {
        toast.error(t('login.oauthError'));
        navigate('/login?error=exchange_failed');
      }
    };

    exchangeCode();
  }, [searchParams, navigate, t, setTokensAndUser]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
      <p>{t('login.processing')}</p>
    </div>
  );
}

export default OAuthCallback;
